import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1391ca92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main-banner-area" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slider" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tp-bullets numbered vertical nav-pos-hor-left nav-pos-ver-center nav-dir-vertical white",
  style: {"height":"55px","width":"15.3167px","top":"50%","transform":"matrix(1, 0, 0, 1, 20, -27)","left":"0px"}
}, null, -1))
const _hoisted_4 = { class: "social-icons-simple revicon white" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"container\" data-v-1391ca92><div class=\"row\" data-v-1391ca92><div class=\"col-md-12\" data-v-1391ca92><div id=\"services-slider\" class=\"owl-carousel\" data-v-1391ca92><div class=\"item\" data-v-1391ca92><div class=\"service-box\" data-v-1391ca92><i class=\"bi bi-lightning-charge-fill\" style=\"font-size:55px !important;\" data-v-1391ca92></i><h4 class=\"bottom10 text-nowrap text-bold\" data-v-1391ca92><a href=\"/layanan-permohonan-daya\" data-v-1391ca92><strong data-v-1391ca92>Dukungan <br data-v-1391ca92> Daya Sementara</strong></a></h4><p class=\"text-color-secondary\" data-v-1391ca92> Permohonan dukungan daya sementara untuk kegiatan </p><a href=\"/layanan-permohonan-daya\" class=\"btn bg-custom-secondary mt-5 text-white\" data-v-1391ca92> Telusuri Layanan </a></div></div><div class=\"item\" data-v-1391ca92><div class=\"service-box\" data-v-1391ca92><i class=\"bi bi-file-earmark-text\" style=\"font-size:55px !important;\" data-v-1391ca92></i><h4 class=\"bottom10 text-nowrap text-bold\" data-v-1391ca92><a href=\"/layanan-iuptl\" data-v-1391ca92><strong data-v-1391ca92>Pelaporan <br data-v-1391ca92> IUPTLS / IUPTLU / IUJPTL</strong></a></h4><p data-v-1391ca92> Pelaporan Izin Usaha Penyedia Tenaga Listrik Sementara / Izin Usaha Penyedia Tenaga Listrik Umum / Izin Usaha Jasa Penyedia Tenaga Listrik </p><a href=\"/layanan-iuptl\" class=\"btn bg-custom-secondary text-white\" data-v-1391ca92> Telusuri Layanan </a></div></div><div class=\"item\" data-v-1391ca92><div class=\"service-box\" data-v-1391ca92><i class=\"bi bi-envelope-paper\" style=\"font-size:55px !important;\" data-v-1391ca92></i><h4 class=\"bottom10 text-nowrap text-bold\" data-v-1391ca92><a href=\"/layanan-suket\" data-v-1391ca92><strong data-v-1391ca92>Pelaporan <br data-v-1391ca92> Surat Keterangan</strong></a></h4><p data-v-1391ca92> Pelaporan Usaha Penyediaan Tenaga Listrik Untuk Kepentingan Sendiri </p><a href=\"/layanan-suket\" class=\"btn bg-custom-secondary mt-5 text-white\" data-v-1391ca92> Telusuri Layanan </a></div></div></div></div></div></div>", 1)
const _hoisted_7 = {
  id: "about",
  class: "single-feature padding mt-n5"
}
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "row d-flex align-items-center" }
const _hoisted_12 = {
  class: "col-lg-6 text-sm-left text-center wow fadeInLeft",
  "data-wow-delay": "300ms"
}
const _hoisted_13 = { class: "heading-title mb-4" }
const _hoisted_14 = { class: "darkcolor font-normal bottom30" }
const _hoisted_15 = { class: "defaultcolor" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { class: "bottom35" }
const _hoisted_18 = {
  class: "col-lg-6 wow fadeInRight",
  "data-wow-delay": "300ms"
}
const _hoisted_19 = { class: "image" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  id: "bg-counters",
  class: "padding bg-counters"
}
const _hoisted_22 = { class: "container" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "align-items-center text-center mb-2" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-white" }, "Statistik")
], -1))
const _hoisted_24 = { class: "row align-items-center text-center mt-5" }
const _hoisted_25 = { class: "col-lg-4 col-md-4 col-sm-4 bottom10" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-user text-white",
  style: {"font-size":"60px"}
}, null, -1))
const _hoisted_27 = { class: "counters whitecolor top10 bottom10" }
const _hoisted_28 = { class: "font-light" }
const _hoisted_29 = { class: "col-lg-4 col-md-4 col-sm-4 bottom10" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-envelope text-white",
  style: {"font-size":"60px"}
}, null, -1))
const _hoisted_31 = { class: "whitecolor fs-1 top10 bottom10" }
const _hoisted_32 = { class: "font-light" }
const _hoisted_33 = { class: "col-lg-4 col-md-4 col-sm-4 bottom10" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-charging-station text-white",
  style: {"font-size":"60px"}
}, null, -1))
const _hoisted_35 = { class: "whitecolor fs-1 top10 bottom10" }
const _hoisted_36 = { class: "font-light" }
const _hoisted_37 = { class: "charts-container" }
const _hoisted_38 = { class: "chart-box full-width" }
const _hoisted_39 = { class: "chart-box" }
const _hoisted_40 = { class: "chart-box" }
const _hoisted_41 = {
  id: "",
  class: "bglight padding_top padding_bottom_half",
  style: {"background-image":"url(/fe/asset/img/merg1.png)","background-size":"100% 100%"}
}
const _hoisted_42 = { class: "container" }
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-1391ca92><div class=\"col-md-12 text-center wow fadeIn top15\" data-wow-delay=\"300ms\" style=\"visibility:visible;animation-delay:300ms;animation-name:fadeIn;\" data-v-1391ca92><h2 class=\"text-white font-normal bottom30\" data-v-1391ca92> Berita <span class=\"defaultcolor\" data-v-1391ca92>Terkini</span></h2><div class=\"col-md-6 offset-md-3 bottom40 text-white\" data-v-1391ca92><p data-v-1391ca92></p></div></div></div>", 1)
const _hoisted_44 = { class: "cbp cbp-ready" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "mt-3 mb-3" }
const _hoisted_47 = { class: "news_item shadow text-center text-md-left" }
const _hoisted_48 = ["href"]
const _hoisted_49 = ["src"]
const _hoisted_50 = {
  class: "news_desc text-center",
  style: {"max-height":"300px","min-height":"300px"}
}
const _hoisted_51 = { class: "text-capitalize font-normal defaultcolor" }
const _hoisted_52 = ["href"]
const _hoisted_53 = { class: "meta-tags top10 bottom20" }
const _hoisted_54 = ["href"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt" }, null, -1))
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = ["href"]
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-sm-12" }
const _hoisted_60 = { class: "pagination top55 justify-content-center mb-4 mb-md-0 mb-sm-3" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = {
  class: "bglight padding_top padding_bottom_half",
  style: {"background-image":"url(/fe/asset/img/merg2.png)","background-size":"100% 100%"}
}
const _hoisted_63 = { class: "container" }
const _hoisted_64 = /*#__PURE__*/_createStaticVNode("<br data-v-1391ca92><br data-v-1391ca92><br data-v-1391ca92><div class=\"row\" data-v-1391ca92><div class=\"col-md-12 text-center wow fadeIn top55\" data-wow-delay=\"300ms\" style=\"visibility:visible;animation-delay:300ms;animation-name:fadeIn;\" data-v-1391ca92><h2 class=\"text-white font-normal bottom30\" data-v-1391ca92> Galeri <span class=\"defaultcolor\" data-v-1391ca92>Kegiatan</span></h2><div class=\"col-md-6 offset-md-3 bottom40 text-white\" data-v-1391ca92><p data-v-1391ca92></p></div></div></div>", 4)
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-lg-12" }
const _hoisted_70 = {
  id: "mosaic-filter",
  class: "cbp-l-filters bottom30 wow fadeIn text-center",
  "data-wow-delay": "350ms"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "All", -1))
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = ["onClick", "data-filter"]
const _hoisted_74 = { class: "col-lg-12" }
const _hoisted_75 = {
  id: "",
  class: "cbp cbp-ready"
}
const _hoisted_76 = { class: "text-center demo-image__preview" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_highcharts = _resolveComponent("highcharts")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSocialMedia, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "d-table",
            key: index
          }, [
            _createElementVNode("a", {
              href: item.url,
              class: ""
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(item.icon)
              }, null, 2)
            ], 8, _hoisted_5)
          ]))
        }), 128))
      ])
    ]),
    _hoisted_6,
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h2", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.aboutUsData.title_1), 1),
                    _hoisted_16,
                    _createTextVNode(" " + _toDisplayString(_ctx.aboutUsData.title_2), 1)
                  ])
                ]),
                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.aboutUsData.content), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("img", {
                    alt: "SEO",
                    src: _ctx.getFilePath('about-us', _ctx.aboutUsData.image)
                  }, null, 8, _hoisted_20)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("h3", _hoisted_28, [
                _createElementVNode("b", null, _toDisplayString(_ctx.statistikData.total_user), 1),
                _createTextVNode(" Pengguna ")
              ], 512), [
                [_vShow, !_ctx.isLoading]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _withDirectives(_createElementVNode("h3", _hoisted_32, [
                _createElementVNode("b", null, _toDisplayString(_ctx.statistikData.suket), 1),
                _createTextVNode(" Laporan Terkirim")
              ], 512), [
                [_vShow, !_ctx.isLoading]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _withDirectives(_createElementVNode("h3", _hoisted_36, [
                _createElementVNode("b", null, _toDisplayString(_ctx.statistikData.spklu), 1),
                _createTextVNode(" Total SPKLU")
              ], 512), [
                [_vShow, !_ctx.isLoading]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_highcharts, { options: _ctx.chartSumSuket }, null, 8, ["options"])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_highcharts, { options: _ctx.chartPltd }, null, 8, ["options"])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_highcharts, { options: _ctx.chartPlts }, null, 8, ["options"])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _hoisted_43,
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listBerita, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item,
                class: "col-md-4"
              }, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("a", {
                      href: `/news-detail?prefix=${item.slug}`,
                      class: "image"
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.getFilePath('news', item.thumbnail),
                        alt: "Latest News",
                        class: "img-responsive",
                        style: {"max-height":"180px !important","object-fit":"cover"}
                      }, null, 8, _hoisted_49)
                    ], 8, _hoisted_48),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("h5", _hoisted_51, [
                        _createElementVNode("a", {
                          href: `/news-detail?prefix=${item.slug}`
                        }, _toDisplayString(item.title), 9, _hoisted_52)
                      ]),
                      _createElementVNode("ul", _hoisted_53, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: `/news-detail?prefix=${item.slug}`
                          }, [
                            _hoisted_55,
                            _createTextVNode(_toDisplayString(_ctx.fomatDateTimeIndo(item.createdAt)), 1)
                          ], 8, _hoisted_54)
                        ])
                      ]),
                      _createElementVNode("p", {
                        class: "bottom35 text-white",
                        innerHTML: _ctx.limitString(item.content, 100)
                      }, null, 8, _hoisted_56),
                      _createElementVNode("a", {
                        href: `/news-detail?prefix=${item.slug}`,
                        class: "button btn-secondary bg-custom"
                      }, "Selengkapnya", 8, _hoisted_57)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("ul", _hoisted_60, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(
                  _ctx.beritaMeta.total / _ctx.beritaMeta.limit
                ), (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass(["page-item", _ctx.beritaMeta.page == index + 1 ? 'active' : '']),
                    key: index
                  }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "javascript:void(0)",
                      onClick: ($event: any) => (_ctx.handlePage(index + 1))
                    }, _toDisplayString(index + 1), 9, _hoisted_61)
                  ], 2))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_62, [
      _createElementVNode("div", _hoisted_63, [
        _hoisted_64,
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", {
                "data-filter": "*",
                class: _normalizeClass(["cbp-filter-item text-white", 
                _ctx.galeryParams.parent_id == '' ? 'cbp-filter-item-active' : ''
              ]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleFilterGalery('')))
              }, _hoisted_72, 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listAlbums, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item,
                  onClick: ($event: any) => (_ctx.handleFilterGalery(item.slug)),
                  "data-filter": `.${item.slug}`,
                  class: _normalizeClass(["cbp-filter-item", 
                _ctx.galeryParams.parent_id == item.slug
                  ? 'cbp-filter-item-active'
                  : ''
              ])
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.title), 1)
                ], 10, _hoisted_73))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("div", _hoisted_76, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listGallery, (item, key) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                    _createVNode(_component_el_image, {
                      style: {"max-width":"200px","max-height":"200px","object-fit":"cover"},
                      src: _ctx.getFilePath('gallery', item.image),
                      "zoom-rate": 1.2,
                      "max-scale": 7,
                      "min-scale": 0.2,
                      "preview-src-list": _ctx.srcList,
                      "initial-index": 4,
                      fit: "cover",
                      onShow: _ctx.handleShow,
                      onClose: _ctx.handleClose
                    }, null, 8, ["src", "preview-src-list", "onShow", "onClose"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                      return (_openBlock(), _createBlock(_component_el_image, {
                        key: child,
                        style: {"max-width":"200px","max-height":"200px","object-fit":"cover"},
                        src: _ctx.getFilePath('gallery', child.image),
                        "zoom-rate": 1.2,
                        "max-scale": 7,
                        "min-scale": 0.2,
                        "preview-src-list": _ctx.srcList,
                        "initial-index": 4,
                        fit: "contain",
                        onShow: _ctx.handleShow,
                        onClose: _ctx.handleClose
                      }, null, 8, ["src", "preview-src-list", "onShow", "onClose"]))
                    }), 128))
                  ], 64))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}